import React from 'react';
import propTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ component, exact = false, path, restricted, authenticated }) => (
  <Route
    exact={exact}
    path={path}
    render={props => (
      (restricted && authenticated ? (
        <Redirect to={{
          pathname: '/dashboard/pm-dashboard',
          state: { from: props.location }
        }}/>
      ) : (
        React.createElement(component, props)
      ))
    )}
  />
);

PublicRoute.propTypes = {
  component: propTypes.oneOfType([propTypes.object, propTypes.func]).isRequired,
  exact: propTypes.bool,
  path: propTypes.oneOfType([propTypes.object, propTypes.array, propTypes.string]).isRequired,
  authenticated: propTypes.bool.isRequired,
  location: propTypes.object
};

export default PublicRoute;
